import { Component, OnDestroy, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";
import { ApiResponse } from "src/app/shareModule/models/common.model";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { RoleService } from "src/app/shareModule/services/roles/role.service";
import { SharedService } from "src/app/shareModule/services/shared.service";
import { CustomerService } from "src/app/shareModule/services/customer.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { TemplateRefDiamondsService } from "../profile-character/level-profile/diamonds-popup/template-ref-diamonds.service";
import { ModalService } from "src/app/shareModule/services/modal.service";
import { CommonService } from "src/app/shareModule/services/common.service";
import { select, Store } from "@ngrx/store";
import { loadUser, selectUser } from "src/app/shareModule/states/user-details";
import { filter, Subject, takeUntil } from "rxjs";
import { User } from "src/app/shareModule/models/user.model";
import { LocalServiceService } from "../../../../shareModule/services/local-service.service";
import { AppState } from "src/app/shareModule/states/app.state";

@Component({
  selector: "app-setting-profile",
  templateUrl: "./setting-profile.component.html",
  styleUrls: ["./setting-profile.component.scss"],
})
export class SettingProfileComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  profileInfo: any = { isVerified: false };
  public modalRef: any = null;
  public selectedOTP: any = "";
  public invalidOtp: string = "";
  public charName: string = "";
  public email: string = "";
  public isEmailVerify: boolean = false;
  public currentEmail: string = "";
  public postalCode: string = "";
  public currentPostalCode: string = "";
  public phoneNumber: string = "";
  public shortDescription: string = "";
  public imgUrl = environment.ImageUrl;
  public certifiedSelect: any = [
  ];
  public certifiedValue: any = [];
  public regionList = [];
  public selectedMemberRegion = "";
  public selectedMemberRegionId = "";
  public buyerContact: boolean = false;
  selectedTheme: string = "space";
  tutorials: boolean = JSON.parse(localStorage.getItem("tutorials")) || false;
  showVerification = false;
  showVerificationTelegram = false;

  telegramLink: string = "";

  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    public roleService: RoleService,
    private sharedService: SharedService,
    private customerService: CustomerService,
    public modalService: NgbModal,
    private http: HttpClient,
    private templateRefDiamondsService: TemplateRefDiamondsService,
    public commonService: CommonService,
    private store: Store<AppState>,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    this.commonService.regionObserver.subscribe((resp: any) => {
      this.regionList = resp.map((i) => {
        return {
          keyName: i.name,
          sub: i.subRegions.map((i: any) => {
            return { ...i, keyName: i.name };
          }),
        };
      });
    });

    this.store
      .pipe(select(selectUser))
      .pipe(
        filter((user) => !!user)
      )
      .subscribe((resp: User) => {
        const data = resp;
        this.charName = data.profileCharacterName;
        this.email = data?.email;
        this.currentEmail = data?.email;
        this.isEmailVerify = data?.isEmailVerify == 0 ? false : true;
        this.postalCode = data.postalCode;
        this.currentPostalCode = data.postalCode;
        this.shortDescription = data.shortDescription;
        this.buyerContact = data.buyerContact === 1;
        this.selectedMemberRegion = data?.regionName || "";
        this.selectedMemberRegionId = data?.region || "";
        try{
          this.certifiedValue = JSON.parse(data?.certified ?? "[]") || [];
        }catch(e){
          console.error(e)
        }
        this.profileInfo = resp || [];
        this.selectedTheme = resp?.theme;
        this.getTelegramLinks();
        this.getCertificate()
      });
  }


  public getCertificate() {
    this.auth.certificateGet().subscribe((result) => {
      result.body.map((row) => {
        if (!this.certifiedSelect.some(item => item.value === row.role)) {
          this.certifiedSelect.push({
            value: row.role,
            label: row.role,
          });
        }
      })
    })
  }

  getTelegramLinks() {
    if (this.profileInfo?.isTelegramVerified) {
      return;
    }
    this.http.get(environment.baseUrlAdmin + "getTelegramVerificationLink").subscribe((e: any) => {
      this.telegramLink = e.telegramLink;
    });
  }

  async sendOtp(modal = null) {
    this.isLoading = true;

    const length = 6;
    const otp = Array.from({ length }, () => Math.floor(Math.random() * 10)).join("");

    // to: `${this.profileInfo.countryCode}${this.profileInfo.phone}`,
    const data = {
      messaging_product: "whatsapp",
      recipient_type: "individual",
      to: `${this.profileInfo.countryCode}${this.profileInfo.phone}`,
      type: "template",
      template: {
        name: "user_otp",
        language: {
          code: "en_US",
        },
        components: [
          {
            type: "body",
            parameters: [
              {
                type: "text",
                text: otp,
              },
            ],
          },
          {
            type: "button",
            sub_type: "url",
            index: "0",
            parameters: [
              {
                type: "text",
                text: otp,
              },
            ],
          },
        ],
      },
    };

    const token = environment.whtsappCloudToken;

    await fetch(environment.whtsappCloudUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    await this.http
      .post(environment.baseUrlAdmin + "member_save_otp_marketplace", {
        phoneNumber: this.profileInfo?.phone,
        otp,
      })
      .subscribe((response) => {
      });

    this.isLoading = false;
    this.otpSent = true;

    return true;
  }

  transformArray(arr) {
    const grouped = arr.reduce((acc, item) => {
      const [category, location] = item.name.split("|");
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push({
        id: item.id,
        keyName: location,
        name: category,
        region: location,
        value: item.name,
      });
      return acc;
    }, {});

    return Object.keys(grouped).map((key) => ({
      keyName: key,
      sub: grouped[key],
    }));
  }

  onRegionClick(obj) {
    this.selectedMemberRegion = obj?.name;
    this.selectedMemberRegionId = obj?.subRegionId;
    try {
      this.postalCode = JSON.parse(obj.postalCode).join(",") || "";
    } catch (e) {
      this.postalCode = "";
    }
  }

  public saveProfileInfo(): void {
    // Validate email using the pattern
    // if (!(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(this.email)) {
    //   this.toastr.error('Please enter a valid email address.');
    //   return;
    // }

    // if ((this.email && !this.currentEmail) || (this.email != this.currentEmail)) {
    //   this.saveMemberEmail(this.email);
    // } else {

    let payload = {
      profileCharacterName: this.charName,
      shortDescription: this.shortDescription,
      certifiedValue: JSON.stringify(this.certifiedValue),
      region: this.selectedMemberRegionId,
      buyerContact: this.buyerContact ? "1" : "0",
      theme: this.selectedTheme,
    };

    if (this.postalCode != this.currentPostalCode) {
      if (this.postalCode.length != 6) {
        this.toastr.error("Postal code should be 6 digits");
        return;
      }
      payload["postalCode"] = this.postalCode;
    }

    this.auth.updateProfileCharacterDetails(payload).subscribe(
      (resp: ApiResponse) => {
        if (resp.message) {
          this.store.dispatch(loadUser({}));
          this.toastr.success(resp.message);
        }
      },
      ({ error }) => {
        this.toastr.error(error.message);
      }
    );
    // }
  }

  public saveMemberEmail(email) {
    this.customerService
      .saveMemberEmail({
        email: email,
      })
      .subscribe(
        (resp: ApiResponse) => {
          if (resp.message) {
            this.toastr.success(resp.message);
            this.store.dispatch(loadUser({}));
          }
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  onThemeChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const theme = selectElement.value;
    localStorage.setItem("selectedTheme", theme);
    if (this.selectedTheme) {
      document.documentElement.classList.remove(this.selectedTheme);
    }
    document.documentElement.classList.add(theme);
    this.selectedTheme = theme;
  }
  onTutorialsChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    localStorage.setItem("tutorials", JSON.stringify(isChecked));
    this.tutorials = isChecked;
  }
  public otpSent: boolean = false;
  public otp: string = "";
  public passcode: string = "";
  public passcodeConfirm: string = "";
  public isLoading: boolean = false;
  public otpError: string = "";
  public isReset: boolean = false;
  openVerificationPopup() {
    this.showVerification = !this.showVerification;
  }

  delaySendOTP: number = 0;
  handleSendOTP() {
    if (this.delaySendOTP < 1)
      this.auth
        .member_send_otp({
          phone: this.profileInfo?.phone,
        })
        .subscribe(
          (resp: any) => {
            const result = resp.body;
            if (result.success) {
              this.toastr.success(resp.message);
            } else {
              this.toastr.error(resp.message);
            }
            this.delaySendOTP = 61;
            let interval = setInterval(() => {
              this.delaySendOTP -= 1;
              if (this.delaySendOTP == 0) {
                clearInterval(interval);
              }
            }, 1000);
          },
          (e) => {
            this.toastr.error("Internal Server Error");
          }
        );
  }

  handleVerify() {
    if (this.passcode == "") return this.toastr.error("Please Fill Passcode");
    if (this.passcode != this.passcodeConfirm) {
      return this.toastr.error("Passcode Confirmation Doesn't Match");
    }

    if (this.otp == "") return this.toastr.error("Please Fill OTP");

    this.auth
      .member_reset_passcode({
        password: this.passcode,
        otp: this.otp,
        phone: this.profileInfo?.phone,
      })
      .subscribe(
        (resp: any) => {
          const result = resp.body;
          if (result.success) {
            this.showVerification = false;
            this.toastr.success(resp.message);
          } else {
            this.toastr.error(resp.message);
          }
        },
        (e) => {
          this.toastr.error("Internal Server Error");
        }
      );
  }

  async onChangeOtp(e: any) {
    this.otp = e.target.value;
  }

  async onChangePasscode(e: any) {
    this.passcode = e.target.value;
  }

  GoToMyTabs(index: any) {
    this.sharedService.triggerSelectMyTab(index);
  }

  public verifyEmailOtp() {
    if (this.selectedOTP && this.selectedOTP.length == 6) {
      this.customerService
        .verifyEmailOtp({
          otp: this.selectedOTP,
          email: this.email,
        })
        .subscribe(
          (resp: ApiResponse) => {
            if (resp.message) {
              this.store.dispatch(loadUser({}));
              this.toastr.success(resp.message);
              this.modalRef ? this.modalRef.close() : "";
            }
          },
          ({ error }) => {
            this.toastr.error(error.message);
          }
        );
    } else {
      this.toastr.error("Invalid OTP!");
    }
  }

  public handleOTPVerification(modal: any) {
    this.selectedOTP = "";
    this.modalRef = this.modalService.open(modal, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "suggestion",
    });
  }

  public isPostalConfirmed: boolean = false;
  public filterSubregions() {
    if (this.isPostalConfirmed) {
      this.isConfirm();
    } else {
      this.local
        .alertConfirm({
          message: `All Product will be Delisted, Are you sure want to change postal code ?`,
        })
        .then((resp) => {
          if (resp.isConfirmed) {
            this.isPostalConfirmed = true;
            this.isConfirm();
          } else {
            this.postalCode = this.currentPostalCode;
          }
        });
    }
  }

  public isConfirm() {
    let region = this.commonService.getSubRegionBaseOnPostalCode(this.postalCode) || "";
    this.selectedMemberRegion = region ? region?.name : "";
    this.selectedMemberRegionId = region ? region?.subRegionId : "";
  }

  public updateCertificate(value) {
    this.certifiedValue = value.value || [];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
